// extracted by css-extract-rspack-plugin
export default {"dividerWrapper":"divider-wrapper--Zc3BvJNC3weLAxER"};